import { useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { Check, ContentCopy } from "@mui/icons-material";

// Shortened ID in a small monospace pill; clicking copies the full value
export default function CopyableTypography(
  {
    text,
  }
) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  function shortenText(text) {
    if (text) {
      return text.slice(0, 4).toUpperCase() + " … " + text.slice(-4).toUpperCase();
    }
    return "";
  }

  if (!text) return null;

  return (
    <Tooltip title={copied ? "Copied" : `Copy ${text}`} placement="top">
      <Box
        component="button"
        type="button"
        onClick={handleCopy}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          px: 1,
          py: 0.25,
          border: "1px solid var(--c-border)",
          borderRadius: "8px",
          backgroundColor: "var(--c-surface)",
          color: copied ? "var(--c-success)" : "var(--c-text-3)",
          cursor: "pointer",
          font: "inherit",
          transition: "background-color 120ms ease, border-color 120ms ease",
          "&:hover": { backgroundColor: "var(--c-subtle)", borderColor: "var(--c-border-strong)" },
        }}
      >
        <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 12, lineHeight: 1.6 }}>
          {shortenText(text)}
        </Typography>
        {copied
          ? <Check sx={{ fontSize: 14 }} />
          : <ContentCopy sx={{ fontSize: 13, color: "var(--c-text-faint)" }} />}
      </Box>
    </Tooltip>
  );
}
